import React from "react"
import { render } from "react-dom"
import "./globalStyle.css"
import "normalize.css"
import App from "./app"

render(<App />, document.getElementById("root"))
